<ng-template>
   <div lcsSingleSelectPanel [visible]="isPanelVisible">
      @if (isIncludeEmptyOption) {
      <lcs-option>
         {{ overrideEmptyOption !== '' ? overrideEmptyOption : '' }}
      </lcs-option>
      } @for ( queueManagementStrategy of queueManagementStrategies | async; track trackBy(queueManagementStrategy) ) {
      <lcs-option
         [value]="queueManagementStrategy"
         id="lcs-option-id-{{ queueManagementStrategy.queueManagementStrategyTypeId }}"
      >
         {{ displayWith(queueManagementStrategy) }}
      </lcs-option>
      }
   </div>
</ng-template>
